import { useT } from '@/lib/useLang';

/**
 * La citation, reprise deux fois sur la page (hero et section Focus).
 *
 * Elle est signée par l'équipe, pas par une personne nommée : le texte est
 * traduit, et attribuer une phrase traduite à quelqu'un de réel lui fait dire
 * mot pour mot ce qu'il n'a pas dit. La maquette la signait « Tom Benattar,
 * CEO » ; si Stephen veut ce nom, il faut d'abord une citation réelle par
 * langue (voir `quote` / `quoteAuthor` dans `i18n/index.ts`).
 */
export function FounderQuote({ bare = false }: { bare?: boolean }) {
  const t = useT();

  return (
    <figure className={`nz-quote${bare ? ' nz-quote--bare' : ''}`}>
      <div className="nz-in" aria-hidden="true">
        in
      </div>
      <figcaption>
        <p className="nz-quote__text">{t.quote}</p>
        <div className="nz-quote__author">{t.quoteAuthor}</div>
      </figcaption>
    </figure>
  );
}
